import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from './createLogger';
import analyticsPlugins from '../analytics/index.js';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const state = {
  sampleData: null,
  policiesData: null,
  hasBlockingError: {
    hasError: false,
    error: '',
    caller: '',
    closeHandler: null,
  },
};
// Asynchronous mutations which can be called from components  and should make a caal to mutation
const actions = {

  //Capital case
  SetSampleData({ commit, dispatch }) {
    const mutationName = 'setSampleData';
    try {
      if (mutationName in this._mutations) {
        commit(mutationName);
      } else {
        throw `mutation ${mutationName} doesnot exist`;
      }
    } catch (error) {
      // if it is blocking error and needs to stop user , use this method

      // dispatch('SetBlockingError', {
      //   err: `${mutationName} at the first stage  in the store- exception:  ${error}`,
      //   caller: 'SetBlockingError',
      // });
    }
  },

  SetBlockingError({ commit }, payload) {
    commit('setBlockingError', payload);
  },

  // eslint-disable-next-line no-empty-pattern
  analytics({ }, data) {
    if (analyticsPlugins(Vue.prototype.$logger)) {
      analyticsPlugins(Vue.prototype.$logger).customWatcher(data.actionName, data.entityChange);
    }
  },

};

// Synchronous mutations which can be called from components or actions
const mutations = {
  //LowerCase
  setSampleData(state, payload) {
    this.state.sampleData = payload;
  },
  setPoliciesData(state, payload) {
    state.policiesData = payload;
  },
  setBlockingError(state, payload) {
    state.hasBlockingError = {
      hasError: true,
      error: payload.err,
      caller: payload.caller,
      closeHandler: payload.closeHandler,
      actionType: payload.actionType || 'sync',
    };
  },
};

const getters = {
  //start with get
  getErrorStatus: (state) => state.hasBlockingError,
};

export default new Vuex.Store({
  modules: {},
  state,
  actions,
  mutations,
  getters,
  strict: debug,
  plugins: debug ? [createLogger({logger: Vue.prototype.$logger}), analyticsPlugins(Vue.prototype.$logger).storeWatcher] : [analyticsPlugins(Vue.prototype.$logger).storeWatcher],
});
